<!--
  가. 작업장 상황 조사 — 한 항목(작업 설비 / 작업량 / 작업 속도 / 업무 변화)의 라디오 묶음
  "변화 없음" 외 항목을 고르면 그 항목 옆에 "언제부터" 입력 칸이 나타난다.
  value: { value: '변화 없음' | '줄음' | ..., text: '언제부터' }
-->
<template>
  <div class="situation-row">
    <p class="situation-title">{{ title }}</p>
    <div class="flex flex-wrap items-center gap-y-3 gap-x-6">
      <div v-for="item in items" :key="`${radioName}_${item.value}`" class="flex items-center gap-2">
        <!-- 인쇄 -->
        <template v-if="isPrint">
          <i class="print-radio-icon"><feather-icon v-if="current.value === item.value" svgClasses="w-4 h-4" icon="CheckIcon" /></i>
          <span>{{ item.value }}</span>
          <p v-if="item.textInput && current.value === item.value" class="print-input situation-input">{{ current.text }}</p>
        </template>
        <!-- 작성 -->
        <template v-else>
          <vs-radio :vs-name="radioName" :vs-value="item.value" :value="current.value" :disabled="readonly" @input="onSelect">{{ item.value }}</vs-radio>
          <!-- "변화 없음" 외 항목은 선택했을 때만 "언제부터" 입력 칸을 보여준다 -->
          <ml-input v-if="item.textInput && current.value === item.value" :readonly="readonly" :value="current.text" @input="(text) => onInputText(item, text)" placeholder="언제부터" class="situation-input" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SituationRadioRow",
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    title: String,
    radioName: { type: String, required: true },
    // [{ value: '변화 없음', textInput: false }, { value: '줄음', textInput: true }, ...]
    items: { type: Array, required: true },
    value: Object,
  },
  computed: {
    current() {
      return this.value && typeof this.value === "object" ? { value: this.value.value || "", text: this.value.text || "" } : { value: "", text: "" };
    },
  },
  methods: {
    onSelect(value) {
      if (this.readonly) return;
      // 선택을 바꾸면 이전 항목에 적은 "언제부터" 는 비운다
      this.$emit("input", { value, text: "" });
    },
    onInputText(item, text) {
      // ml-input 은 마운트 시에도 input 을 내보내므로, 선택된 항목의 입력만 반영한다
      if (item.value !== this.current.value) return;
      if (text === this.current.text) return;
      this.$emit("input", { value: this.current.value, text });
    },
  },
};
</script>

<style scoped lang="scss">
.situation-row {
  padding: 12px 0 20px;
}
.situation-title {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 14px;
}
.situation-input {
  width: 220px;
  min-width: 160px;
}
.print-radio-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid #cdcdcd;
  border-radius: 20px;
}
</style>
